import React, { useEffect, useRef } from "react";
import classes from "./Stepper.module.css";

const Stepper = (props) => {
  const indicator1 = useRef(null);
  const indicator2 = useRef(null);
  const indicator3 = useRef(null);
  const circle1 = useRef(null);
  const circle2 = useRef(null);
  const circle3 = useRef(null);
  const circle4 = useRef(null);

  useEffect(() => {
    if (props.step === 1) {
      circle1.current.style.backgroundColor = "#FCCE01";
      circle2.current.style.backgroundColor = "#014480";
      circle3.current.style.backgroundColor = "#014480";
      circle4.current.style.backgroundColor = "#014480";
      indicator1.current.style.width = "0%";
      indicator2.current.style.width = "0%";
      indicator3.current.style.width = "0%";
    }
    if (props.step === 2) {
        circle1.current.style.backgroundColor = "#FCCE01";
        circle2.current.style.backgroundColor = "#FCCE01";
        circle3.current.style.backgroundColor = "#014480";
        circle4.current.style.backgroundColor = "#014480";
        indicator1.current.style.width = "100%";
        indicator2.current.style.width = "0%";
        indicator3.current.style.width = "0%";
    }
    if (props.step === 3) {
        circle1.current.style.backgroundColor = "#FCCE01";
        circle2.current.style.backgroundColor = "#FCCE01";
        circle3.current.style.backgroundColor = "#FCCE01";
        circle4.current.style.backgroundColor = "#014480";
        indicator1.current.style.width = "100%";
        indicator2.current.style.width = "100%";
        indicator3.current.style.width = "0%";
    }
    if (props.step === 4) {
        circle1.current.style.backgroundColor = "#FCCE01";
        circle2.current.style.backgroundColor = "#FCCE01";
        circle3.current.style.backgroundColor = "#FCCE01";
        circle4.current.style.backgroundColor = "#FCCE01";
        indicator1.current.style.width = "100%";
        indicator2.current.style.width = "100%";
        indicator3.current.style.width = "100%";
    }
  }, [props.step]);

  return (
    <div className={classes.container}>
      <div className={classes.circle} ref={circle1}>
        1
      </div>
      <div className={classes.indicator}>
        <div className={classes.progress} ref={indicator1}></div>
      </div>
      <div className={classes.circle} ref={circle2}>
        2
      </div>
      <div className={classes.indicator}>
        <div className={classes.progress} ref={indicator2}></div>
      </div>
      <div className={classes.circle} ref={circle3}>
        3
      </div>
      <div className={classes.indicator}>
        <div className={classes.progress} ref={indicator3}></div>
      </div>
      <div className={classes.circle} ref={circle4}>
        4
      </div>
    </div>
  );
};
export default Stepper;
